export default "__VITE_ASSET__BPmBeZxG__"